import React, { useEffect, useState } from "react";
import "./style.css";
import adminLogo from "../assets/admin.png";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import { Modal } from "react-bootstrap";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Link } from "react-router-dom";
import { errorAlert } from "../utils/errorAlert";
import swal from "sweetalert";
import Loader from "./loader";
import config from "../config";
import { grey } from "@mui/material/colors";

const drawerWidth = 240;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

// React.useEffect{()=>{
// }}

const Header = () => {
  const [panel, setPanel] = useState(true);
  const [responsedata, setResponseData] = useState([]);
  const [responseUsersListdata, setUsersListResponseData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedExpert, setSelectedExpert] = useState({});
  const [edit, setEdit] = React.useState(false);
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [existingPage, updateExistingPage] = useState(1);
  const [modalopen, setModalOpen] = React.useState(false);
  const [approvalStatus, setApprovalStatus] = React.useState(false);
  const [responseObj, setResponseObj] = useState({});
  const [usersListResponseObj, setUsersListResponseObj] = useState({});
  const [totalPages, setTotalPages] = useState({});
  const [pateintTotalPages, setPatientTotalPages] = useState({});


  const authToken = localStorage.getItem("token");

  const getAllExperts = (page) => {
    // setLoading(true);
    fetch(`${config.url}/api/admin/getExpertList`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({
        limit: 50,
        currentPage: page ? page : existingPage,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        setResponseObj(response);
        setResponseData(response.expertsList);
        setTotalPages(response.totalPages);
        setLoading(false);
        return response;
      })
      .catch((err) => {
        setLoading(false);
        return err;
      });
  };

  useEffect(() => {
    getAllExperts();
  }, []);

  const getAllUsers = (page) => {
    // setLoading(true);
    fetch(`${config.url}/api/admin/getUsersList`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({
        limit: 50,
        currentPage: page ? page : existingPage,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        setUsersListResponseObj(response);
        setUsersListResponseData(response.usersList);
        setPatientTotalPages(response.totalPages);
        setLoading(false);
        return response;
      })
      .catch((err) => {
        setLoading(false);
        return err;
      });
  };

  useEffect(() => {
    getAllUsers();
  }, []);

  const previousPage = () => {
    if (existingPage !== 1) {
      let page = existingPage - 1;
      updateExistingPage(page);
      getAllExperts(page, "1");
      getAllUsers(page, "1");
    }
  };

  const nextPage = () => {
    let responseTotalPages;

    if (panel) {
      responseTotalPages = responseObj;

      // console.log("On true ------------>", responseTotalPages);
    } else {
      responseTotalPages = usersListResponseObj;

      // console.log("On false -------->", responseTotalPages);
    }

    if (responseTotalPages) {
      const { totalPages } = responseTotalPages;
      if (existingPage !== totalPages) {
        let page = existingPage + 1;
        updateExistingPage(page);
        getAllExperts(page, "1");
        getAllUsers(page, "1");
      }
    }
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleOpen = (event) => {
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };
  // Patient APRROVAL FUNCTIONS
  const changeStatusOfUser = (data, status, keyStatus) => {
    {
      keyStatus == "patient" ? setPanel(false) : setPanel(true);
    }

    swal({
      closeOnEsc: false,
      closeOnClickOutside: false,
      text: `Do you want to ${status} this user ?`,
      buttons: ["No", "Yes"],
    }).then((value) => {
      if (value) {
        changeUserStatus(data._id, status);
      }
    });
  };

  const changeUserStatus = (userId, status, keyStatus) => {
    fetch(`${config.url}/api/admin/userApproval`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({
        userId: userId,
        status: status,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        swal({
          closeOnEsc: false,
          closeOnClickOutside: false,
          title: "Success",
          text: response.message,
        }).then((value) => {
          const tempArr = [...responseUsersListdata];
          const index = tempArr.findIndex((element) => element._id === userId);
          tempArr[index] = {
            ...tempArr[index],
            isApproved: !tempArr[index].isApproved,
          };
          setUsersListResponseData(tempArr);
          setLoading(false);
          return response;
        });
      })
      .catch((err) => {
        setLoading(false);
        return err;
      });
  };

  // Expert APRROVAL FUNCTIONS
  const changeStatusOfExpert = (data, status) => {
    swal({
      closeOnEsc: false,
      closeOnClickOutside: false,
      text: `Do you want to ${status} this expert ?`,
      buttons: ["No", "Yes"],
    }).then((value) => {
      if (value) {
        changeStatus(data._id, status);
      }
    });
  };

  const changeStatus = (expertId, status) => {
    fetch(`${config.url}/api/admin/expertValidate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({
        expertId: expertId,
        status: status,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        swal({
          closeOnEsc: false,
          closeOnClickOutside: false,
          title: "Success",
          text: response.message,
        }).then((value) => {
          const tempArr = [...responsedata];

          const index = tempArr.findIndex(
            (element) => element._id === expertId
          );
          tempArr[index] = {
            ...tempArr[index],
            isActive: !tempArr[index].isActive,
          };
          setResponseData(tempArr);

          setLoading(false);
          return response;
        });
      })
      .catch((err) => {
        setLoading(false);
        return err;
      });
  };

  const clearAllFields = () => {
    setName("");
    setMobile("");
    setAddress("");
    setCity("");
  };

  // Function To register New Expert

  const registerExpert = (e) => {
    e.preventDefault();
    setModalOpen(true);
    if (name.trim() === "") {
      errorAlert({ title: "Error", message: "Name required" });
      return;
    }
    if (mobile.length < 10 || mobile.length > 10) {
      errorAlert({
        title: "Error",
        message: "Mobile number length should be 10 digits",
      });
      return;
    }
    if (address === "") {
      errorAlert({ title: "Error", message: "Address required" });
      return;
    }
    if (city === "") {
      errorAlert({ title: "Error", message: "City required" });
      return;
    }

    fetch(`${config.url}/api/auth/expert`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({
        name: name.trim(),
        mobile: mobile,
        address: address,
        city: city,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        // setModalOpen(false);
        if (response.status === "error") {
          errorAlert({
            title: "Error",
            message: response.message,
          });
          return;
        } else {
          swal({
            closeOnEsc: false,
            closeOnClickOutside: false,
            title: "Success",
            text: response.message,
            // timer: 1000,
            // buttons: false,
          }).then((value) => {
            // setEdit(false);
            // window.location.reload();

            const tempArr = [...responsedata];
            console.log(tempArr, "befrpe Push");
            const obj = {
              name: name.trim(),
              mobile: mobile,
              address: address,
              city: city,
            };
            tempArr.unshift(obj);
            setResponseData(tempArr);
            console.log(tempArr, "After Push");
          });
        }
        setLoading(false);
        setModalOpen(false);
        return response;
      })
      .catch((err) => {
        errorAlert({
          title: "Error",
          message: err,
        });
        setLoading(false);
        return err;
      });
  };

  // Function To Edit registered Expert Details
  const checkClicked = (e) => {
    e.preventDefault();
    if (selectedExpert.name.trim() === "") {
      errorAlert({ title: "Error", message: "Name required" });
      return;
    }
    if (selectedExpert.mobile === "") {
      errorAlert({ title: "Error", message: "Mobile  required" });
      return;
    }
    if (
      selectedExpert.mobile.length < 10 ||
      selectedExpert.mobile.length > 10
    ) {
      errorAlert({
        title: "Error",
        message: "Mobile number length should be minimum of 10 digits",
      });
      return;
    }
    if (selectedExpert.address === "") {
      errorAlert({ title: "Error", message: "Address required" });
      return;
    }
    if (selectedExpert.city === "") {
      errorAlert({ title: "Error", message: "City required" });
      return;
    }

    fetch(`${config.url}/api/expert/updateExpert`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },

      body: JSON.stringify({
        expertId: selectedExpert._id,
        name: selectedExpert.name.trim(),
        mobile: selectedExpert.mobile,
        address: selectedExpert.address,
        city: selectedExpert.city,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        // swal("response.data");
        setModalOpen(false);

        if (response.status === "error") {
          errorAlert({
            title: "Error",
            message: response.message,
          });
          return;
        } else {
          swal({
            closeOnEsc: false,
            closeOnClickOutside: false,
            title: "Success",
            text: response.message,
            // timer: 1000,
            // buttons: false,
          }).then((value) => {
            setEdit(false);
            // window.location.reload();
            const tempArr = [...responsedata];
            const index = tempArr.findIndex(
              (element) => element._id === selectedExpert._id
            );
            tempArr[index] = {
              ...tempArr[index],
              name: selectedExpert.name.trim(),
              mobile: selectedExpert.mobile,
              address: selectedExpert.address,
              city: selectedExpert.city,
            };
            setResponseData(tempArr);

            setLoading(false);
            setModalOpen(false);
            return response;
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        return err;
      });
  };
  const renderTotalPages = () => {
    // console.log("total Pages ---------->", responseObj.totalPages);

    // console.log(
    //   "Total pAGES OF USER ------------>",
    //   usersListResponseObj.totalPages
    // );

    return (
      <div className="paginationContainer">
        <div className="containerInner">
          <div data-test="datatable-select" className="selectParent">
            <label
              style={{ alignSelf: "flex-end" }}
            >{panel ?  (`Current page:  ${existingPage}/${totalPages}`) : (`Current page:  ${existingPage}/${pateintTotalPages}`)}</label>
            <div>
              {panel ? (
                <div style={{ float: "right" }}>
                  <div style={{ display: "flex" }}>
                    <div className="arrow" onClick={() => previousPage()}>
                      <div
                        className={existingPage === 1 ? "disabledArrow" : ""}
                      >
                        <i className="fas fa-chevron-left"></i>
                      </div>
                    </div>
                    <div
                      className="arrow"
                      data-test="page-item"
                      onClick={() => nextPage()}
                    >
                      <div
                        className={
                          existingPage === responseObj.totalPages
                            ? "disabledArrow"
                            : ""
                        }
                      >
                        <i className="fas fa-chevron-right"></i>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div style={{ float: "right" }}>
                  <div style={{ display: "flex" }}>
                    <div className="arrow" onClick={() => previousPage()}>
                      <div
                        className={existingPage === 1 ? "disabledArrow" : ""}
                      >
                        <i className="fas fa-chevron-left"></i>
                      </div>
                    </div>
                    <div
                      className="arrow"
                      data-test="page-item"
                      onClick={() => nextPage()}
                    >
                      <div
                        className={
                          existingPage === usersListResponseObj.totalPages
                            ? "disabledArrow"
                            : ""
                        }
                      >
                        <i className="fas fa-chevron-right"></i>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleChange = (value, field) => {
    if (field === "name") {
      setSelectedExpert({ ...selectedExpert, name: value });
    }
    if (field === "mobile") {
      setSelectedExpert({ ...selectedExpert, mobile: value });
    }
    if (field === "address") {
      setSelectedExpert({ ...selectedExpert, address: value });
    }
    if (field === "city") {
      setSelectedExpert({ ...selectedExpert, city: value });
    }
  };

  const editClicked = (data) => {
    setEdit(true);
    setSelectedExpert(data);
  };

  const logoutClicked = () => {
    swal({
      closeOnEsc: false,
      closeOnClickOutside: false,
      title: "Logout",
      text: "Are you sure, you want to logout?",
      buttons: ["No", "Yes"],
    }).then((value) => {
      if (value) {
        localStorage.clear();
        window.location.assign("/");
      }
    });
  };

  if (loading) {
    return <Loader />;
  }
  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar position="fixed" open={open}>
          <Toolbar style={{ backgroundColor: "#eaeef4", color: "#000" }}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{ mr: 2, ...(open && { display: "none" }) }}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" noWrap component="div"></Typography>

            {panel ? (
              <div style={{ float: "left" }}>Grad Experts List</div>
            ) : (
              <div style={{ float: "left" }}>Grad Patients List</div>
            )}
            {panel && (
              <div  style={{ position: "absolute", right: "125px", cursor: "pointer" }}>
                <button
                  style={{ float: "right", marginBottom: "-5px" , height : "35px"}}
                  className="btn btn-primary-add"
                  onClick={() => {
                    handleOpen();
                    clearAllFields();
                  }}
                >
                  Add New Expert
                </button>
              </div>
            )}
            <div
              style={{ position: "absolute", right: "25px", cursor: "pointer" }}
              onClick={logoutClicked}
            >
              Logout
              <i
                className="fa fa-sign-out"
                aria-hidden="true"
                style={{
                  paddingLeft: "10px",
                  fontSize: "20px",
                  verticalAlign: "middle",
                }}
              ></i>
            </div>
          </Toolbar>
        </AppBar>
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
            },
          }}
          variant="persistent"
          anchor="left"
          open={open}
        >
          <DrawerHeader>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "ltr" ? (
                <ChevronLeftIcon />
              ) : (
                <ChevronRightIcon />
              )}
            </IconButton>
          </DrawerHeader>

          <center>
            <img
              style={{ "margin-top": "-20px", width: "100px", height: "100px" }}
              src={adminLogo}
            />
          </center>

          <center style={{ "margin-top": "20px" }}>
            <div
              className="sideButton"
              onClick={() => {
                setPanel(true);
                updateExistingPage(1);
                getAllExperts("1");
              }}
              style={{ backgroundColor: panel ? "#49b585" : "" }}
            >
              Expert
            </div>
          </center>

          <center style={{ "margin-top": "2px" }}>
            <div
              className="sideButton"
              onClick={() => {
                setPanel(false);
                updateExistingPage(1);
                getAllUsers("1");
              }}
              style={{ backgroundColor: panel ? "" : "#49b585" }}
            >
              Patient
            </div>
          </center>
        </Drawer>
        {panel ? (
          <Main open={open}>
            <DrawerHeader />
            <Typography paragraph>
              {/* <button
                style={{ float: "right", marginBottom: "15px" }}
                className="btn btn-primary-add"
                onClick={() => {
                  handleOpen();
                  clearAllFields();
                }}
              >
                Add New Expert
              </button> */}

              <table className="table table-bordered">
                <thead>
                  <tr style={{ background: "#49B585", color: "#fff" }}>
                    <th scope="col">S.No</th>
                    <th scope="col">Expert Name</th>
                    <th scope="col">Mobile Number</th>
                    <th scope="col">Address</th>
                    <th scope="col">City</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {responsedata && responsedata.length > 0 ? (
                    responsedata.map((data, index) => (
                      <tr key={data._id}>
                        {edit && selectedExpert._id === data._id ? (
                          <React.Fragment>
                            <th scope="row">{existingPage * 50 + 1}</th>
                            <td>
                              <input
                                type="text"
                                className="form-control hideFoucus"
                                defaultValue={data.name}
                                onChange={(e) =>
                                  handleChange(e.target.value, "name")
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control hideFoucus"
                                defaultValue={data.mobile}
                                onChange={(e) =>
                                  handleChange(e.target.value, "mobile")
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control hideFoucus"
                                defaultValue={data.address}
                                onChange={(e) =>
                                  handleChange(e.target.value, "address")
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control hideFoucus"
                                defaultValue={data.city}
                                onChange={(e) =>
                                  handleChange(e.target.value, "city")
                                }
                              />
                            </td>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <th scope="row">
                              {existingPage === 1
                                ? index + 1
                                : (existingPage - 1) * 50 + index + 1}
                            </th>
                            <td>{data.name}</td>
                            <td>{data.mobile}</td>
                            <td>{data.address}</td>
                            <td>{data.city}</td>
                          </React.Fragment>
                        )}
                        <td>
                          {edit && selectedExpert._id === data._id ? (
                            <Link
                              role="button"
                              onClick={(e) => checkClicked(e)}
                              to="#"
                            >
                              <i className="fas fa-check"></i>
                            </Link>
                          ) : (
                            <>
                              <Link
                                role="button"
                                onClick={() => editClicked(data)}
                                to="#"
                              >
                                <i
                                  className="fas fa-edit"
                                  style={{
                                    color: "#222c43",
                                  }}
                                ></i>
                              </Link>

                              {data.isActive === true ? (
                                <Link
                                  role="button"
                                  onClick={() =>
                                    changeStatusOfExpert(data, "deactivate")
                                  }
                                  to="#"
                                >
                                  <i
                                    className="fas fa-times"
                                    title="Deactivate"
                                    style={{
                                      marginLeft: "15px",
                                      color: "#ff0000",
                                    }}
                                  ></i>
                                </Link>
                              ) : (
                                <Link
                                  role="button"
                                  onClick={() =>
                                    changeStatusOfExpert(data, "activate")
                                  }
                                  to="#"
                                >
                                  <i
                                    className="fas fa-check"
                                    title="Activate"
                                    style={{
                                      marginLeft: "15px",
                                      color: "#00FF00",
                                    }}
                                  ></i>
                                </Link>
                              )}
                            </>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <td colSpan="10">
                      <p style={{ fontSize: "20px", marginTop: "10px" }}>
                        No data available
                      </p>
                    </td>
                  )}
                </tbody>
              </table>
              <div className="paginationBox">
                {responsedata && responsedata.length > 0
                  ? renderTotalPages()
                  : ""}
              </div>
            </Typography>
          </Main>
        ) : (
          <Main open={open}>
            <DrawerHeader />
            <Typography paragraph>
              {/* <button
            style={{ float: "right", marginBottom: "15px" }}
            className="btn btn-primary-add"
            onClick={() => {
              handleOpen();
              clearAllFields();
            }}
          >
            Add New Expert
          </button> */}

              <table className="table table-bordered">
                <thead>
                  <tr style={{ background: "#49B585", color: "#fff" }}>
                    <th scope="col">S.No</th>
                    <th scope="col">Patient Name</th>
                    <th scope="col">Mobile Number</th>
                    <th scope="col">Address</th>
                    <th scope="col">City</th>
                    <th scope="col">Country</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {responseUsersListdata && responseUsersListdata.length > 0 ? (
                    responseUsersListdata.map((data, index) => (
                      <tr key={data._id}>
                        <React.Fragment>
                          <th scope="row">
                            {existingPage === 1
                              ? index + 1
                              : (existingPage - 1) * 50 + index + 1}
                          </th>
                          <td>{data.name}</td>
                          <td>{data.mobile}</td>
                          <td>{data.streetAddress}</td>
                          <td>{data.city}</td>
                          <td>{data.countryName}</td>
                        </React.Fragment>

                        <td>
                          {data.isApproved ? (
                            <Link
                              role="button"
                              onClick={(e) =>
                                changeStatusOfUser(
                                  data,
                                  "disapprove",
                                  "patient"
                                )
                              }
                              to="#"
                            >
                              <i className="fas fa-times"></i>
                            </Link>
                          ) : (
                            <>
                              <Link
                                role="button"
                                onClick={() =>
                                  changeStatusOfUser(
                                    data,
                                    "approved",
                                    "patient"
                                  )
                                }
                                to="#"
                              >
                                <i
                                  className="fas fa-check"
                                  title="Approve"
                                  style={{
                                    color: "#222c43",
                                  }}
                                ></i>
                              </Link>
                            </>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <td colSpan="10">
                      <p style={{ fontSize: "20px", marginTop: "10px" }}>
                        No data available
                      </p>
                    </td>
                  )}
                </tbody>
              </table>
              <div className="paginationBox">
                {responseUsersListdata && responseUsersListdata.length > 0
                  ? renderTotalPages()
                  : ""}
              </div>
            </Typography>
          </Main>
        )}
      </Box>

      <Modal
        show={modalopen}
        onHide={() => handleClose()}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body style={{ backgroundColor: "#fff" }}>
          <div className="container">
            <div className="d-flex  mt-4">
              <h4 style={{ marginRight: "auto"  }}>Add New Expert</h4>
              <a
                href="#"
                className="close-icon"
                onClick={() => {
                  handleClose();
                  clearAllFields();
                }}
              ></a>
            </div>
            <div className="popUpBody mt-4">
              <div className="row">
                <form>
                  <div className="row mb-4">
                    <div className="col">
                      <div className="form-outline">
                        <input
                          type="text"
                          id="form3Example1"
                          className="form-control hideFoucus"
                          placeholder="Name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col">
                      <div className="form-outline">
                        <input
                          type="number"
                          id="form3Example2"
                          className="form-control hideFoucus"
                          placeholder="Mobile"
                          value={mobile}
                          onChange={(e) => setMobile(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row mb-4">
                    <div className="col">
                      <div className="form-outline">
                        <input
                          type="text"
                          id="form3Example2"
                          className="form-control hideFoucus"
                          placeholder="Address"
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="col">
                      <div className="form-outline">
                        <input
                          type="email"
                          id="form3Example1"
                          className="form-control hideFoucus"
                          placeholder="City"
                          value={city}
                          onChange={(e) => setCity(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <button
                    type="button"
                    className="btn btn-primary btn-block mb-4 submitButton"
                    onClick={(e) => registerExpert(e)}
                  >
                    Done
                  </button>
                </form>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Header;
